import type {ComponentProps} from 'react';
import {cn} from '../lib/cn';

export type SkeletonProps = ComponentProps<'div'>;

export function Skeleton({className, ...props}: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'animate-pulse rounded-md bg-[var(--chekin-color-gray-3)]',
        className,
      )}
      {...props}
    />
  );
}
